import React, { useState } from 'react';
import EdenredButtons from '@pages/DesignSystem/button/EdenredButton';
import Edenredmodal from '../index';

const ModelFifteen = () => {
	const [isOpen, setisOpen] = useState(false);

	return (
		<>
			<EdenredButtons
				{...{
					btnType: 'primary',
					onClick: () => setisOpen(true),
					style: { marginTop: '20px' },
				}}>
				Modal With heart and no button
			</EdenredButtons>

			<Edenredmodal
				{...{
					title: 'Do You Want To Continue?',
					desc: 'Edenred',
					heart: true,
					isOpen: isOpen,
					close: () => setisOpen(false),
					textcenter: true,
				}}
			/>
		</>
	);
};

export default ModelFifteen;
